import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { Simdata5gAction } from 'src/actions/simdata5g.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getSimdata5gStatus } from 'src/utils/utils';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";

const TheHomepageSimdata5gDetail = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page");
  const [selectedSimdata5gIds, setSelectedSimdata5gIds] = useState([]);
  const [homepageSimdata5gLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE);
  const [homepageSimdata5gPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageSimdata5gItems, homepageSimdata5gTotal, homepageSimdata5gFilter } = useSelector(state => state.simdata5g);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)
  const { isLoading } = useSelector(state => state.app);
  
  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])
  
  useEffect(() => {
    const payload = {
      ...homepageSimdata5gFilter,
      homepageSimdata5gLimit: homepageSimdata5gLimit,
      homepageSimdata5gPage: homepageSimdata5gPage,
    };
    dispatch(Simdata5gAction.updateHomepageFilter(payload));
    dispatch(Simdata5gAction.homepageList())
  }, [homepageSimdata5gPage, homepageSimdata5gLimit])

  const handleSelectAll = (event) => {
    let newSelectedSimdata5gIds;

    if (event.target.checked) {
      newSelectedSimdata5gIds = homepageSimdata5gItems.map((simdata5g) => simdata5g.slug);
    } else {
      newSelectedSimdata5gIds = [];
    }

    setSelectedSimdata5gIds(newSelectedSimdata5gIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedSimdata5gIds.indexOf(id);
    let newSelectedSimdata5gIds = [];

    if (selectedIndex === -1) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(selectedSimdata5gIds, id);
    } else if (selectedIndex === 0) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(selectedSimdata5gIds.slice(1));
    } else if (selectedIndex === selectedSimdata5gIds.length - 1) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(selectedSimdata5gIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSimdata5gIds = newSelectedSimdata5gIds.concat(
        selectedSimdata5gIds.slice(0, selectedIndex),
        selectedSimdata5gIds.slice(selectedIndex + 1)
      );
    }

    setSelectedSimdata5gIds(newSelectedSimdata5gIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);

    // Gán giá trị mặc định
    queryParams.set("page", newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, simdata5g) => {
    setSelected(simdata5g);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(Simdata5gAction.del(selected.slug))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(Simdata5gAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageSimdata5gTotal / homepageSimdata5gLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageSimdata5gPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageSimdata5gPage - 2); i <= Math.min(totalPages - 1, homepageSimdata5gPage + 2); i++) {
              pages.push(i);
          }
          if (homepageSimdata5gPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageSimdata5gPage || page === "..."} style={{
                  padding: "8px 12px", background: page === homepageSimdata5gPage ? "var(--main-color)" : "var(--main-color)", color: "#fff",
                  border: "none", borderRadius: "5px", cursor: page === homepageSimdata5gPage || page === "..." ? "default" : "pointer",
                  margin: "0", transition: "0.3s"
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // hoặc 'auto'
    });
  };

  return (
    <>
        <Helmet>
            <title>Sim data 5G | Kho số - Di Dong Telecom</title>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className='simdata5g-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px" }}>
            {homepageSimdata5gItems && homepageSimdata5gItems.slice(homepageSimdata5gPage * homepageSimdata5gLimit, homepageSimdata5gPage * homepageSimdata5gLimit + homepageSimdata5gLimit).map((simdata5g, index) => (
                simdata5g ? <Link to={`/trang-chu/sim-data-5g/${simdata5g.slug}`} className="simdata5g-item" onClick={scrollToTop} onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "block", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                    {simdata5g.trang_thai == "da_ban" && <div class="pause-stamp">HẾT HÀNG</div>}
                    {simdata5g.image?.match(/\.(mp4|webm|ogg)$/i) ? (
                        <video src={simdata5g.image} controls style={{ opacity: simdata5g.trang_thai == "da_ban" ? "0.8" : "1.0", width: "100%", height: "200px" }} />
                    ) : (
                        <img src={simdata5g.image ? simdata5g.image : ''} alt={simdata5g.title ? simdata5g.title : ''} style={{ opacity: simdata5g.trang_thai == "da_ban" ? "0.8" : "1.0", width: "100%", height: "200px", objectFit: "cover" }} />
                    )}
                    <div style={{ opacity: simdata5g.trang_thai == "da_ban" ? "0.8" : "1.0", width: "100%" }}>
                        <div className="name">{simdata5g.name}</div>
                        <div className="price">
                          {(Number(simdata5g.price_new) > 0 && Number(simdata5g.price_new) < Number(simdata5g.price)) ? (
                            <div>
                              <span style={{ color: 'red', fontWeight: 'bold' }}>
                                {numeral(simdata5g.price_new).format('0,0')}₫
                              </span>
                              <br></br>
                              <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                                {numeral(simdata5g.price).format('0,0')}₫
                              </span>
                            </div>
                          ) : (
                            <div>
                              <span style={{ fontWeight: 'bold' }}>
                                {numeral(simdata5g.price).format('0,0')}₫
                              </span>
                            </div>
                          )}
                        </div>
                    </div>
                </Link> : null
            ))}
        </div>}

        {!isLoading && <div className='list-pagination' style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "5px" }}>
            <button onClick={(e) => handlePageChange(e, homepageSimdata5gPage - 1)} disabled={homepageSimdata5gPage === 0} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {"<"}
            </button>
            {renderPagination()}
            <button onClick={(e) => handlePageChange(e, homepageSimdata5gPage + 1)} disabled={homepageSimdata5gPage + 1 >= homepageSimdata5gTotal / homepageSimdata5gLimit} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {">"}
            </button>
        </div>}
    </>
  );
};

export default TheHomepageSimdata5gDetail;
